import React from 'react';
import BaseContainer from '../../baseContainers/BaseContainer';
import BlockUi from '../../components/waitPanel/BlockUi';
import BaseBreadCrumb from '../../baseContainers/BaseBreadCrumb';
import CompanyAgreementBanner from '../../components/CompanyAgreementBanner';
import StatisticService from '../../services/StatisticService';
import {withTranslation} from 'react-i18next';
import {withRouter} from 'react-router-dom/cjs/react-router-dom.min';
import InternalUserService from '../../services/MobileUserService';
import RankingService from '../../services/RankingService';
import TransportService from '../../services/TransportService';
import DashboardRankComponent from '../dashboard/DashboardRankComponent';
import DashboardGroupRankComponent from '../dashboard/DashboardGroupRankComponent';
import CompanyTransportService from '../../services/CompanyTransportService';
import CompanyService from '../../services/CompanyService';
import {TabPanel, TabView} from 'primereact/tabview';
import {t} from 'i18next';
import {normalizeGroupPointsAlgorithm} from '../../utils/GroupPointsAlgorithmUtils';

class RankingContainer extends BaseContainer {
    constructor(props) {
        super(props);
        this.state = {
            monthTravelKilometers: {
                currentMonthValue: undefined,
                percentageDeviationByPrevMonth: undefined,
            },
            monthSavedCo2: {
                currentMonthValue: undefined,
                percentageDeviationByPrevMonth: undefined,
            },
            monthFinishedChallengesCount: {
                currentMonthValue: undefined,
                percentageDeviationByPrevMonth: undefined,
            },
            transportTypes: [],
            renderMap: false,
            rankingPageable: [],
            groupRankingPageable: [],
            activeTab: 0,
            // todayRoutes: {
            //     coordinates: [],
            // },
            todayRoutes: [],
            kilometersGroupedByMonths: undefined,
            savedCo2GroupedByMonths: undefined,
            dateFrom: undefined,
            dateTo: undefined,
            participateInGlobalChallenge: false,
            groupPointsAlgorithm: undefined,
        };

        this.statisticService = new StatisticService();
        this.companyService = new CompanyService();
        this.transportService = new TransportService();
        this.companyTransportService = new CompanyTransportService();
        this.rankingService = new RankingService();
        // TODO:  to tak srednio chyba ze nazywa sie internal

        this.mobileUserService = new InternalUserService();
    }

    componentDidMount() {
        super.componentDidMount();
        this.fetchParticipateInGlobalChallenge();
        this.fetchCompanyGroupPointsAlgorithm();
        this.fetchMonthTravelKilometers();
        this.fetchSavedCo2();
        this.fetchTodayCoordinates();
        this.fetchKilometerGroupByMonths();
        this.fetchSavedCo2GroupByMonths();
        this.fetchMonthFinishedChallengesCount();
        this.fetchTransportDictTypes();
        this.fetchGroupRanking(this.getGroupRankingCleanSearchCriteria());
    }
    fetchCompanyGroupPointsAlgorithm = () => {
        this.companyService
            .get()
            .then((data) => {
                this.setState({
                    groupPointsAlgorithm: normalizeGroupPointsAlgorithm(data?.groupPointsAlgorithm),
                });
            })
            .catch(() => {});
    };
    fetchParticipateInGlobalChallenge = () => {
        this.companyService
            .getCompanySetting('PARTICIPATE_IN_GLOBAL_CHALLENGE')
            .then((value) => {
                this.setState({ participateInGlobalChallenge: value === 'true' || value === true });
            })
            .catch(() => {});
    };
    fetchTransportDictTypes = () => {
        this.companyTransportService
            .getTransportDictTypes()
            .then((res) => {
                const transportTypes = res.transportTypes;
                if (transportTypes.length === 0) {
                    return;
                }
                const transportTypesWithSteps = [...transportTypes, { name: 'Kroki', transportId: '-1' }];
                this.setState(
                    {
                        transportTypes: transportTypesWithSteps,
                    },
                    () => {
                        this.fatchRanking(this.getRankingCleanSearchCriteria());
                    }
                );
            })
            .catch(() => {
                this.showErrorMessage('Nie można typów transportu');
            });
    };
    fetchMonthTravelKilometers = () => {
        this.statisticService
            .getKilometersTraveledMonth()
            .then((res) => {
                this.setState({monthTravelKilometers: res});
            })
            .catch(() => {
                this.showErrorMessage('Nie można pobrać statystyk misięcznych transportu');
            });
    };
    fetchSavedCo2 = () => {
        this.statisticService
            .getSavedCo2Month()
            .then((res) => {
                this.setState({monthSavedCo2: res});
            })
            .catch(() => {
                this.showErrorMessage('Nie można pobrać statystyk misięcznych zaoszczedzonego CO2');
            });
    };
    fetchMonthFinishedChallengesCount = () => {
        this.statisticService
            .getFinishedChallengesCountInMonth()
            .then((res) => {
                this.setState({monthFinishedChallengesCount: res});
            })
            .catch(() => {
                this.showErrorMessage('Nie można pobrać statystyk misięcznych transportu');
            });
    };
    fetchKilometerGroupByMonths = () => {
        this.statisticService
            .getChartKilometersTraveledByMonth()
            .then((res) => {
                this.setState({kilometersGroupedByMonths: res.content});
            })
            .catch(() => {
                this.showErrorMessage('Nie można pobrać statystyk miesięcznych transportu');
            });
    };
    fetchSavedCo2GroupByMonths = () => {
        this.statisticService
            .getChartSavedCo2ByMonth()
            .then((res) => {
                this.setState({savedCo2GroupedByMonths: res.content});
            })
            .catch(() => {
                this.showErrorMessage('Nie można pobrać statystyk miesięcznych zaoszczedzonego CO2');
            });
    };
    fetchTodayCoordinates = () => {
        this.blockUi();
        this.statisticService
            .getTodayCoordinates()
            .then((res) => {
                this.setState({todayRoutes: res.userTransports, renderMap: true});
                this.unblockUi();
            })
            .catch(() => {
                this.showErrorMessage('Nie można pobrać dzisiejszych koordynatów');
            });
    };

    fatchRanking(criteria) {
        if (
            (criteria.transportId && criteria.transportId === '-1') ||
            (criteria.name && criteria.name === 'Kroki')
        ) {
            criteria.activityType = 'STEPS';
        } else if (criteria.transportId && criteria.transportId === '-2') {
            criteria.activityType = 'GLOBAL_CHALLENGE';
            criteria.type = 'SAVED_CO2';
        } else {
            delete criteria.activityType;
        }
        this.rankingService
            .getRanking(criteria)
            .then((data) => {
                this.setState({
                    rankingPageable: data,
                });
            })
            .catch(() => {
                this.showErrorMessage('nie można pobrać rankingu');
            });
    }

    fetchGroupRanking(criteria) {
        this.rankingService
            .getGroupRanking(criteria)
            .then((data) => {
                this.setState({
                    groupRankingPageable: data,
                });
            })
            .catch(() => {
                this.showErrorMessage('nie można pobrać rankingu drużynowego');
            });
    }

    getGroupRankingCleanSearchCriteria() {
        const now = new Date();
        const start = new Date(now.getFullYear(), now.getMonth(), 1);
        const end = new Date(now.getFullYear(), now.getMonth() + 1, 0);
        return {
            dateFrom: start,
            dateTo: end,
            firstResult: 0,
            maxResults: 20,
        };
    }

    getRankingCleanSearchCriteria() {
        const now = new Date();
        const start = new Date(now.getFullYear(), now.getMonth(), 1);
        const end = new Date(now.getFullYear(), now.getMonth() + 1, 0);
        return {
            transportId: this.state.transportTypes[0].transportId,
            dateFrom: start,
            dateTo: end,
            firstResult: 0,
            type: 'TRAVELED_DISTANCE',
            maxResults: 20,
        };
    }

    breadCrumbItems() {
        return [{name: 'Ranking'}];
    }
    render() {
        return (
            <React.Fragment>
            
               
                    <div className='container-fluid'>
                    <CompanyAgreementBanner />
                    <BaseBreadCrumb items={this.breadCrumbItems()} />
                    <BlockUi tag='div' blocking={this.state.blocking || this.state.loading} loader={this.loader}>
                        <TabView
                            activeIndex={this.state.activeTab}
                            onTabChange={(e) => {
                                this.setState({activeTab: e.index});
                            }}
                        >
                            <TabPanel header={t('rankingPage.individual')}>
                                <div className='row'>
                                    <div className='col-lg-12'>
                                        {this.state.transportTypes.length !== 0 && (
                                            <DashboardRankComponent
                                                transportTypes={this.state.transportTypes}
                                                rankingTitle={''}
                                                myPlaceTitle={'Moje miejsce'}
                                                rankingPageable={this.state.rankingPageable}
                                                rows={20}
                                                rowsPerPageOptions={[10, 20, 50]}
                                                fatchRanking={(criteria) => {
                                                    this.fatchRanking(criteria);
                                                }}
                                                getRankingCleanSearchCriteria={() => {
                                                    return this.getRankingCleanSearchCriteria();
                                                }}
                                                useDateRange={true}
                                                participateInGlobalChallenge={this.state.participateInGlobalChallenge}
                                            />
                                        )}
                                    </div>
                                </div>
                            </TabPanel>
                            <TabPanel header={t('rankingPage.team')}>
                                <div className='row'>
                                    <div className='col-lg-12'>
                                        <DashboardGroupRankComponent
                                            rankingPageable={this.state.groupRankingPageable}
                                            rows={20}
                                            rowsPerPageOptions={[10, 20, 50]}
                                            groupPointsAlgorithm={this.state.groupPointsAlgorithm}
                                            fatchRanking={(criteria) => {
                                                this.fetchGroupRanking(criteria);
                                            }}
                                            getRankingCleanSearchCriteria={() => {
                                                return this.getGroupRankingCleanSearchCriteria();
                                            }}
                                        />
                                    </div>
                                </div>
                            </TabPanel>
                        </TabView>
                    </BlockUi>
                    </div>

                
            </React.Fragment>
        );
    }
}

RankingContainer.propTypes = {};
export default withRouter(withTranslation()(RankingContainer));
